import type { BigNumber } from '@ethersproject/bignumber'

import { Text } from 'shared/ui/common/Text'
import { Button } from 'shared/ui/controls/Button'
import { EstimatedGasFee } from 'modules/blockChain/ui/EstimatedGasFee'
import { TermsHint } from 'shared/ui/common/TermsHint'
import { protocolPaused } from 'shared/constants/errors'

import s from './NFCSFormPartFooter.module.scss'

type Props = {
  submitText: React.ReactNode
  estimatedGas?: BigNumber | null
  isLoading: boolean
  isContractPaused: boolean
  isDisabled: boolean
  shouldShowHint?: boolean
  onSubmit: () => void
}

export function NFCSFormPartFooter({
  submitText,
  estimatedGas,
  isDisabled,
  isLoading,
  isContractPaused,
  shouldShowHint = true,
  onSubmit,
}: Props) {
  return (
    <>
      {estimatedGas && (
        <EstimatedGasFee
          value={estimatedGas}
          className={s.estiamteGas}
          classNameCta={s.notEnoughCta}
        />
      )}

      {isContractPaused && (
        <Text isCentered color="error">
          {protocolPaused}
        </Text>
      )}

      <Button
        size={72}
        isFullWidth
        onClick={onSubmit}
        isLoading={isLoading}
        isDisabled={isDisabled}
      >
        {submitText}
      </Button>

      {shouldShowHint && <TermsHint />}
    </>
  )
}
